module.exports = __webpack_public_path__ + "img/huangyong.19e42437.jpg";